import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import apiClient from '../../../../../Services/NetteApiClient';
import { format } from 'date-fns';
import TermDatePicker from './TermDatePicker';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-term-date-picker',
	callback: ({ container, context, props }: any) => {
		const changeUrl = container.getAttribute('onchangeurl');
		const value = container.getAttribute('value');
		const workplaceId = container.getAttribute('workplaceId');
		const workplaceMemberId = container.getAttribute('workplaceMemberId');
		const workplaceCaseTypeId = container.getAttribute('workplaceCaseTypeId');
		const isFirstRender = parseBoolean(container.getAttribute('isFirstRender'));
		const minDate = container.getAttribute('minDate');
		const maxDate = container.getAttribute('maxDate');

		const handleChange = (date: Date) => {
			apiClient.post(changeUrl, {
				date: format(date, 'yyyy-MM-dd'),
			});
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<TermDatePicker
						onChange={handleChange}
						minDate={minDate}
						maxDate={maxDate}
						value={value}
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						workplaceCaseTypeId={workplaceCaseTypeId}
						isFirstRender={isFirstRender}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
